import ScrollToTop from "../../hooks/ScrollToTop";
import PageHeader from "../../components/layout/PageHeader.jsx";
import PreviousStepContainer from "../../components/common/PreviousStepContainer";
import NextStepContainer from "../../components/common/NextStepContainer.jsx";
import SavedNotice from "../../components/common/SavedNotice";
import ActivityManager from "../../components/impactStrategy/ActivityManager.jsx";

/**
 * Route wrapper for Activiteiten. The CRUD lives in <ActivityManager> (reused
 * inline in the TOC navigator); this page adds the chrome.
 */
const Activities = () => {
    ScrollToTop();

    return (
        <div className="main">
            <div className="main-container">
                <PageHeader
                    heading={'Activiteiten'}
                    description={`In deze stap benoem je de activiteiten die je uitvoert. De activiteiten zijn de concrete acties die je onderneemt om je impactdoel te bereiken. Elke activiteit heeft zijn eigen output(s), dit zijn direct telbare effecten. Bijvoorbeeld aantal deelnemers, aantal diploma's, aantal geholpen mensen, verminderde aantal hulpvragen, aantal maatschappelijke projecten etc. Elke activiteit kun je koppelen aan een of meerdere doelgroepen.`}
                    AI={true}
                />

                <ActivityManager />

                <div className="impactstrategy-saved-and-nextstep-container">
                    <SavedNotice />
                    <div id='next-step-container'>
                        <PreviousStepContainer url={'stakeholders'} mainItem={'impactstrategy'}/>
                        <NextStepContainer url={'Effects'} mainItem={'impactstrategy'}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Activities
